import { ICustomField } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryConfig } from "@ws-react-query";
import { CustomFieldListFilters } from "../../../services/customFields";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_CUSTOM_FIELDS_ALL } from "../keys";

/**
 * Custom fields are DISABLED during the v3 migration.
 *
 * The v1 `/payments/custom-fields` list is retired (it throws `NotMigrated`),
 * and every v3 custom-field endpoint still declares `501 NotImplemented`, so
 * there is no source for these definitions on either API. This resolves to an
 * empty list rather than failing: consumers that only read `data` degrade to
 * "no custom fields", and the screens that gate on it inside `WSQueries` — the
 * payable create/edit forms, the bulk uploaders — keep rendering.
 *
 * Restore the v3 read here once `GET /v3/platform/custom-fields` is implemented;
 * the filters argument is kept so no call site has to change.
 */
export const useQueryCustomFieldsAll = (
  filters?: CustomFieldListFilters,
  config?: WSQueryConfig<Array<ICustomField>, WSServiceError>
) => {
  return useWSQuery<Array<ICustomField>, WSServiceError>(
    [QUERY_CUSTOM_FIELDS_ALL, { filters }],
    async () => [],
    {
      ...config
    }
  );
};
